import subscriptionService from "../services/subscription.service";

const unwrap = (response) =>
  response?.data?.data ?? response?.data?.body ?? response?.data;

export const getBillingStatus = async (accountUrn) => {
  const res = await subscriptionService.getBillingStatus(accountUrn);
  return unwrap(res);
};

export const getSubscriptionInvoices = async (subscriptionId, accountUrn) => {
  const res = await subscriptionService.getInvoices(subscriptionId, accountUrn);
  return unwrap(res) || [];
};

export const createSubscriptionPortalSession = async (accountUrn) => {
  const res = await subscriptionService.createPortalSession(accountUrn);
  return unwrap(res);
};

export const cancelSubscription = async (subscriptionId, accountUrn) => {
  const res = await subscriptionService.cancelSubscription(subscriptionId, accountUrn);
  return unwrap(res);
};
